export default __webpack_public_path__ + "static/media/linkIcon.94db18e7.svg";